import { memo } from 'react';
import { useTheme } from '../../hooks/useTheme';
import { SkeletonCircle, SkeletonLine } from '../common/Skeleton.web';

interface NotificationsListSkeletonProps {
  count?: number;
}

export const NotificationsListSkeleton = memo(
  function NotificationsListSkeleton({
    count = 6,
  }: NotificationsListSkeletonProps) {
    const { theme } = useTheme();

    return (
      <div style={{ backgroundColor: theme.background, flex: 1 }}>
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={`notification-skeleton-${index}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '22px 20px',
              borderBottom:
                index === count - 1
                  ? 'none'
                  : `1px solid ${theme.borderSubtle}`,
            }}
          >
            <SkeletonCircle size={48} />
            <div
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
              }}
            >
              <SkeletonLine width="68%" height={15} />
              <SkeletonLine width="84%" height={14} />
            </div>
          </div>
        ))}
      </div>
    );
  },
);
